/**
 * @generated SignedSource<<4d0fa85365966344e1a9006272de947b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type B2ClockSessionPaymentStatus = "COMPLETED" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "%future added value";
export type B2ClockSessionStatus = "AWAITING_PAYMENT" | "CANCELLED" | "RENTAL_ENDED" | "RENTAL_STARTED" | "%future added value";
export type StripePaymentIntentStatus = "CANCELED" | "PROCESSING" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "REQUIRES_CONFIRMATION" | "REQUIRES_PAYMENT_METHOD" | "SUCCEEDED" | "UNKNOWN" | "%future added value";
export type paySessionQuery$variables = {
  sessionId: string;
};
export type paySessionQuery$data = {
  readonly b2CLockSession: {
    readonly activePayment: {
      readonly amount: number;
      readonly id: string;
      readonly paymentIntentSecret: string | null | undefined;
      readonly stripeStatus: StripePaymentIntentStatus | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly paymentStatus: B2ClockSessionPaymentStatus | null | undefined;
    readonly status: B2ClockSessionStatus;
  } | null | undefined;
};
export type paySessionQuery = {
  response: paySessionQuery$data;
  variables: paySessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "sessionId"
          }
        ],
        "kind": "ObjectValue",
        "name": "by"
      }
    ],
    "concreteType": "B2ClockSession",
    "kind": "LinkedField",
    "name": "b2CLockSession",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "B2ClockSessionPayment",
        "kind": "LinkedField",
        "name": "activePayment",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentIntentSecret",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "paySessionQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "paySessionQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "d22a7af80e1dec05b84caf2c3d629bd2",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "b2CLockSession": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "B2ClockSession"
        },
        "b2CLockSession.activePayment": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPayment"
        },
        "b2CLockSession.activePayment.amount": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Int"
        },
        "b2CLockSession.activePayment.id": (v3/*:: as any*/),
        "b2CLockSession.activePayment.paymentIntentSecret": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "String"
        },
        "b2CLockSession.activePayment.stripeStatus": {
          "enumValues": [
            "CANCELED",
            "PROCESSING",
            "REQUIRES_ACTION",
            "REQUIRES_CAPTURE",
            "REQUIRES_CONFIRMATION",
            "REQUIRES_PAYMENT_METHOD",
            "SUCCEEDED",
            "UNKNOWN"
          ],
          "nullable": true,
          "plural": false,
          "type": "StripePaymentIntentStatus"
        },
        "b2CLockSession.id": (v3/*:: as any*/),
        "b2CLockSession.paymentStatus": {
          "enumValues": [
            "REQUIRES_CAPTURE",
            "REQUIRES_ACTION",
            "COMPLETED"
          ],
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPaymentStatus"
        },
        "b2CLockSession.status": {
          "enumValues": [
            "AWAITING_PAYMENT",
            "RENTAL_STARTED",
            "RENTAL_ENDED",
            "CANCELLED"
          ],
          "nullable": false,
          "plural": false,
          "type": "B2ClockSessionStatus"
        }
      }
    },
    "name": "paySessionQuery",
    "operationKind": "query",
    "text": "query paySessionQuery(\n  $sessionId: UUID!\n) {\n  b2CLockSession(by: {id: $sessionId}) {\n    id\n    status\n    paymentStatus\n    activePayment {\n      id\n      amount\n      stripeStatus\n      paymentIntentSecret\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9815daedb562b713e698878edd393b6";

export default node;
